import deepmerge from 'deepmerge'

export const get = (obj, key, def) => {
  key = key && key.split ? key.split('.') : [key]
  for (let p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undefined
  }
  return obj === undefined ? def : obj
}

const canUseSymbol = typeof Symbol === 'function' && Symbol.for

const REACT_ELEMENT = canUseSymbol ? Symbol.for('react.element') : 0xeac7
const FORWARD_REF = canUseSymbol ? Symbol.for('react.forward_ref') : 0xeac7

const isMergeableObject = n => {
  return (
    !!n &&
    typeof n === 'object' &&
    n.$$typeof !== REACT_ELEMENT &&
    n.$$typeof !== FORWARD_REF
  )
}

const arrayMerge = (destinationArray, sourceArray, options) => sourceArray

export const merge = (a, b) =>
  deepmerge(a, b, { isMergeableObject, arrayMerge })

merge.all = (...args) => deepmerge.all(args, { isMergeableObject, arrayMerge })
